export default __webpack_public_path__ + "static/color-spots-dark-1131e842a561f3deb9c9d14b8dcc1ae4.png";